import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody, LinearProgress, IconButton, ButtonGroup, TableSortLabel, Link
} from '@material-ui/core';
import Content from '../components/Content';
import { deleteMainBook, listMainBooks } from '../services/api';
import EditIcon from '@material-ui/icons/Edit';
import TableNavigation from '../components/general/TableNavigation';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDeleteDialog from '../components/main/book/ConfirmDeleteDialog';
import TableNavigationSearch
  from '../components/main/book/TableNavigationSearch';
import GenericSnack from '../components/GenericSnack';
import TableHeadCell from '../components/general/TableHeadCell';
import moment from 'moment';

const MainBookList = ({ userStore, snackStore }) => {
  const [rows, setRows] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [deletingBook, setDeletingBook] = useState(null);
  const [order, setOrder] = useState({
    order: 'id',
    sort: 'asc'
  });

  const [filters, setFilters] = useState({});

  const navigate = useNavigate();

  const deleteBook = async (bookId) => {
    setDeletingBook(false);
    setLoading(true);
    try {
      await deleteMainBook(bookId, userStore.token)
      loadBooks();
    } catch (e) {
      setLoading(false);
    }
  };

  const loadBooks = async () => {
    setLoading(true);
    try {
      const response = await listMainBooks(currentPage, filters, order, userStore.token);
      if (response.data?.data) {
        setLoading(false);
        setRows(response.data.data.data);
        setPaginationData(response.data.data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleOrder = (field) => {
    setCurrentPage(1);
    setOrder({
      order: field,
      sort: paginationData.ordered_by !== field ? 'asc' : (paginationData.sorted === 'asc' ? 'desc' : 'asc')
    });
  };

  useEffect(() => {
    loadBooks();
  }, [currentPage, order, filters]);

  return (
    <Content title='Livros-Pai' userStore={userStore}>
      <GenericSnack snackStore={snackStore} />
      <TableNavigationSearch
        handleSubmit={filters => {
          setCurrentPage(1);
          setFilters(filters);
        }}
        loading={loading}
        clear={() => {
          setCurrentPage(1);
          setFilters({});
        }}
      />
      <br />
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='b.id' title='ID' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='authors'
                               title='Autores' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='title' title='Título' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='language'
                               title='Idioma' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='publisher' title='Editora' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='release_date' title='Data de lançamento' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='count_books'
                               title='Qtd. de livros vinculados' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='count_quotes'
                               title='Qtd. de trechos vinculados' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='already_read'
                               title='Qtd. listas lidos' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='want_to_read'
                               title='Qtd. listas para ler' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='status'
                               title='Infos G.' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='reviews_status'
                               title='Reviews' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='amazon_status'
                               title='Seller - Amazon' />
                <TableHeadCell paginationData={paginationData} handleOrder={handleOrder} field='meli_status'
                               title='Seller - Meli' />
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={6}><LinearProgress /></TableCell></TableRow>) : rows.map(row => {
                return (<TableRow hover key={row.id}>
                  <TableCell style={{ width: '40px' }}>
                    {row.id}
                  </TableCell>
                  <TableCell style={{ width: '200px' }}>
                    {row.authors}
                  </TableCell>
                  <TableCell style={{ width: '200px' }}>
                    {row.title}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.language}
                  </TableCell>
                  <TableCell style={{ width: '150px' }}>
                    {row.publisher}
                  </TableCell>
                  <TableCell style={{ width: '130px' }}>
                    {row.release_date ? moment(row.release_date).format('DD/MM/YYYY') : ''}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.count_books}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.count_quotes}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.already_read}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.want_to_read}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.status}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.reviews_status}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.amazon_status}
                  </TableCell>
                  <TableCell style={{ width: '100px' }}>
                    {row.meli_status}
                  </TableCell>
                  <TableCell style={{ width: '110px' }}>
                    <ButtonGroup>
                      <Link
                        href={`/app/main/books/edit/${row.id}`}>
                        <IconButton>
                          <EditIcon />
                        </IconButton>
                      </Link>
                      <IconButton
                        onClick={() => setDeletingBook(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>);
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TableNavigation
          totalPages={paginationData.total_pages}
          totalItens={paginationData.total}
          itensPerPage={paginationData.limit}
          currentPage={paginationData.current_page}
          onPageChange={async (page) => {
            setCurrentPage(page);
          }}
        />
      </Card>
      {deletingBook && <ConfirmDeleteDialog open={!!deletingBook}
                                            handleClose={() => setDeletingBook(false)}
                                            book={deletingBook}
                                            handleConfirm={(book) => {
                                              deleteBook(book.id);
                                            }} />}
    </Content>
  );
};

export default MainBookList;
